import { render, staticRenderFns } from "./Branchen.vue?vue&type=template&id=cce97ec0&"
import script from "./Branchen.vue?vue&type=script&lang=ts&"
export * from "./Branchen.vue?vue&type=script&lang=ts&"
import style0 from "./Branchen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports